// Set details of error message
import store from "@/store";
import { ErrorMutation } from "@/framework/store/error/types";
import { i18n } from "@/framework/plugins/i18n";

class CustomError extends Error {
  /** Error type */
  type: CustomError.Type;
  params: any;
  message: string;

  constructor(type: CustomError.Type = CustomError.Type.general, params: any = "", message: string = "") {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
      console.error(this);
      let errorMessage = params.message ? params.message : params;
      if (type !== CustomError.Type.noUser) {
        const msg = message ? `${message}: ${JSON.stringify(errorMessage)}` : `${JSON.stringify(errorMessage)}`;
        this.setErrorMessageControls(msg, type);
      }
    }

    this.name = "CustomError";
    // Custom debugging information
    this.type = type;
    this.params = params;
    this.message = message;
  }

  setErrorMessageControls = (
    errorMessage: string,
    errorType = "",
    title = i18n.t("error_occurred").toString(),
    text = i18n.t("error_detail").toString(),
    dialogSwitch = true
  ) => {
    store.commit(ErrorMutation.SET_DIALOG_CONTROLS, {
      dialog: dialogSwitch,
      title: title,
      text: text,
      errorType: errorType,
      errorMessage: errorMessage,
    });
  };
}

// eslint-disable-next-line no-redeclare
namespace CustomError {
  export enum Type {
    BEError = "Server error",
    graphqlServerError = "Failed to send request to server.",
    general = "General error",
    noUser = "No user",
    noProfile = "No profile",
    cannotConnectCall = "The Guest is experiencing some problem in connecting call....",
    deadlockError = "Another member is now processing",
  }

  export type ApolloGraphQlErrorRes = {
    graphQLErrors?: ApolloGraphQlErrorDetail[];
  };
  export type ApolloGraphQlErrorDetail = {
    message?: string;
    error_id?: string;
    error_code?: string;
  };
}

export default CustomError;
